module.exports = __webpack_public_path__ + "img/panel_normal_off.23e3138f.svg";